import { createApp } from 'vue'
import { createPinia } from 'pinia';
import {useAuthStore} from './store/store.js'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import * as VueRouter from 'vue-router'
import { loadFonts } from './plugins/webfontloader'
import ListPatient from './views/Patient/ListPatient.vue'
import NouveauPatient from './views/Patient/NouveauPatient.vue'
import NouveauMedecin from './components/NouveauMedecin.vue'
import Document from './views/Patient/DocumentPatient.vue'
import Photo from './views/Patient/PhotoPatient.vue'
import Observation from './views/Patient/ObservationPatient.vue'
import Constantes from './views/Patient/ConstantesPatient.vue'
import Patient from './views/Patient/PatientPage.vue'
import Transmission from  './components/transmission.vue'
import TransmissionPatient from  './views/Patient/TransmissionPatient.vue'
 import ListUser from './views/User/UtilisateurList.vue'
 import UserSave from './views/User/UserSave.vue'
 import UserLogin from './views/User/UserLogin.vue'
 import ListTransmission from './components/ListTransmission.vue'
 import ListMedecin from './components/ListMedecin.vue'
 import Menu from './components/Menu.vue'




const router = VueRouter.createRouter({
history: VueRouter.createWebHistory(),
routes: [
  
  {
    path: '/User/Creation',
    name: 'UserSave',
    component: UserSave
    },
    {
      path: '/User/update/:id',
      name: 'UserUpdate',
      component: UserSave
      },
    {
      path: '/User/ListUser',
      name: 'ListUser',
      component: ListUser
      },
      {
        path: '/User/UserLogin',
        name: 'UserLogin',
        component: UserLogin
        },
    {
    path: '/',
    name: 'ListPatient',
    component: ListPatient
    },

    {
      path: '/patient',
      name: 'Patient',
      component: Patient
      },
      {
        path: '/patient/:id',
        name: 'PatientUpdate',
        component: Patient
        },
        {
          path: '/patient/nouveau',
          name: 'PatientNouveau',
          component: Patient
          },

    {
        path: '/updatePatient/:id',
        name: 'UpdatePatient',
        component: NouveauPatient
        },
        {
          path: '/viewPatient/:id',
          name: 'viewPatient',
          component: NouveauPatient
          },
        {
          path: '/observation/:id',
          name: 'Observation',
          component: Observation
          },
          {
            path: '/observationView/:id/:idObs',
            name: 'ObservationView',
            component: Observation
            },
          {
            path: '/observation/:id/:idObs',
            name: 'ObservationUps',
            component: Observation
            },
          {
            path: '/constantes/:id',
            name: 'Constantes',
            component: Constantes
            },
            {
              path: '/constantes/:id/:idConst',
              name: 'ConstantesUpds',
              component: Constantes
              },
              {
                path: '/viewConstantes/:id/:idConst',
                name: 'viewConstantes',
                component: Constantes
                },
          {
            path: '/photo/:id',
            name: 'Photo',
            component: Photo
            }, {
              path: '/photo/:id/:idPhoto',
              name: 'PhotoUpds',
              component: Photo
              },
              {
                path: '/document/:id',
                name: 'Document',
                component: Document
                }, {
                  path: '/document/:id/:idDocument',
                  name: 'DocumentUpds',
                  component: Document
                  },

    {
        path: '/NouveauPatient',
    name: 'NouveauPatient',
    component: NouveauPatient
    },
    {
    path: '/transmission',
    name: 'Transmission',
    component: Transmission
    },
    {
      path: '/transmissionPatient/:id',
      name: 'TransmissionPatient',
      component: TransmissionPatient
      },
    {
      path: '/listtransmission',
      name: 'ListTransmission',
      component: ListTransmission
      },
      {
        path: '/NouveauMedecin',
    name: 'NouveauMedecin',
    component: NouveauMedecin
    },
    {
      path: '/UpdateMedecin/:id',
  name: 'UpdateMedecin',
  component: NouveauMedecin
  },
  {
    path: '/viewMedecin/:id',
    name: 'viewMedecin',
    component: NouveauMedecin
},
    {
      path: '/ListMedecin',
  name: 'ListMedecin',
  component: ListMedecin
  },
  {
    path: '/Menu/:id',
    name: 'Menu',
    component: Menu
    },
  ]
})
router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/User/UserLogin'];
  const authRequired = !publicPages.includes(to.path);
  const auth = useAuthStore();
 let user=localStorage.getItem("user")
  if (authRequired && !user) {
      auth.returnUrl = to.fullPath;
      return '/User/UserLogin';
  }
});
import DatetimePicker from 'vuetify-datetime-picker'


loadFonts()



let app =createApp(App)
app.config.globalProperties.$formatDate = function (date) {
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  return new Intl.DateTimeFormat('fr-FR', options).format(new Date(date));
};
app .use(vuetify)
  .use(router)
  .use(DatetimePicker)
  .use(createPinia())
  .mount('#app')
